import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { NavigationService } from '../../../services/navigation.service';

import list, { hcpLinks, spanishLinks } from '../nav-links';
import { appPaths } from '../../../../app.paths';
import { HelpersService } from '../../../services/helpers.service';
import { GlobalModalService } from '../../../services/global-modal.service';

@Component({
  selector: '[menu-mobile]',
  imports: [CommonModule, RouterModule, NgbCollapseModule],
  templateUrl: './menu-mobile.component.html',
  styleUrl: './menu-mobile.component.scss',
  host: {
    class: 'd-lg-none',
  },
})
export class MenuMobileComponent {
  private helpersService = inject(HelpersService);
  private globalModalService = inject(GlobalModalService);

  navigationService = inject(NavigationService);

  @ViewChildren('dropdownItems') dropdownItems!: QueryList<ElementRef>;

  @Input() isMenuCollapsed = true;
  @Output() collapseMenu = new EventEmitter<boolean>();
  @Input() isSpanish!: boolean;

  appPaths = appPaths;
  list = list;
  hcpLinks = hcpLinks;
  spanishList = spanishLinks;
  isHcpMenuCollapsed = true;

  constructor(private router: Router) {}

  toggleMenuCollapses(id: string) {
    const index = list.findIndex((elm) => elm.id === id);

    list.forEach((elm, i) => {
      if (i != index) {
        elm.isMenuCollapsed = true;
      }
    });

    list[index].isMenuCollapsed = !list[index].isMenuCollapsed;
    this.isHcpMenuCollapsed = true;
  }

  toggleHcpMenuCollapse(e: Event) {
    e.preventDefault();
    list.forEach((elm) => {
      elm.isMenuCollapsed = true;
    });
    this.isHcpMenuCollapsed = !this.isHcpMenuCollapsed;
  }

  collapseTheMenu(value: boolean) {
    //collapse dropdowns
    list.forEach((elm, i) => {
      elm.isMenuCollapsed = true;
    });
    this.isHcpMenuCollapsed = true;

    this.collapseMenu.emit(value);
  }

  isDropdownActive(
    dropdownList: { name: string; path: string }[] = [],
  ): boolean {
    return (
      dropdownList?.some((dropdownItem) =>
        this.router.url.includes(dropdownItem.path),
      ) ?? false
    );
  }

  scrollToSection(id: string) {
    // console.log('clicked');
    const element = document.getElementById(id);
    if (!this.helpersService.validatePlatform()) return;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  spanishLink(url: string) {
    this.globalModalService.openModal('interstitialLongSp', url);
  }

  isHcpLinkActive(path: string): boolean {
    return this.router.url.includes(path);
  }

  openHcpLink(path: string, e: Event) {
    e.preventDefault();
    this.collapseTheMenu(true);
    this.globalModalService.openModal('interstitialHCP', `/${path}`);
  }

  onClick(ul: string, e: Event) {
    if (ul === 'resources') {
      e.preventDefault();
      this.globalModalService.openModal('interstitialHCP', `/${appPaths.RESOURCE}`);
    }
  }
}
